var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [[_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "服务器列表"
    }
  }, [_c("server-list", {
    attrs: {
      isCache: "",
      all: "",
      multiple: true
    },
    model: {
      value: _vm.searchInfo.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "server_id", $$v);
      },
      expression: "searchInfo.server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "查看前n名："
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "120px"
    },
    attrs: {
      placeholder: "输入前多少名"
    },
    model: {
      value: _vm.inputNum,
      callback: function callback($$v) {
        _vm.inputNum = $$v;
      },
      expression: "inputNum"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "选择分类："
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.checkPage();
      }
    }
  }, [_vm._v("点击查看")])], 1)], 1)]], 2), _c("div", [[_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      height: "650",
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      label: "排名"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "openId",
      label: "账号"
    }
  }), _c("el-table-column", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.showType == "role_id",
      expression: "this.showType == 'role_id'"
    }],
    attrs: {
      height: "150",
      label: "角色ID"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("a", {
          staticStyle: {
            cursor: "pointer",
            color: "#409EFF"
          },
          on: {
            click: function click($event) {
              return _vm.goRouterMsg(scope.row.roleId);
            }
          }
        }, [_vm._v(_vm._s(scope.row.roleId))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "roleName",
      label: "角色名"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "区服"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_c("span", [_vm._v(_vm._s(row.serverId))]), row.isFirstRole == 0 ? _c("span", [_vm._v("（滚服）")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "roleLevel",
      label: "等级",
      sortable: ""
    }
  }), _c("el-table-column", {
    attrs: {
      label: "充值金额（后台充值金额）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.totalRmbSource) + " " + _vm._s(scope.row.totalRmb == scope.row.totalRmbSource ? "" : "（" + (scope.row.totalRmbSource - scope.row.totalRmb) + "）") + " 元 ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "createRoleTime",
      label: "注册时间"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "最后登录时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          style: {
            color: _vm.formatDate(scope.row.lastLoginTime) == 1 ? "red" : ""
          }
        }, [_vm._v(" " + _vm._s(scope.row.lastLoginTime) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "最后充值时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          style: {
            color: _vm.formatDate(scope.row.LastPayTime) == 1 ? "red" : ""
          }
        }, [_vm._v(" " + _vm._s(scope.row.LastPayTime) + " ")])];
      }
    }])
  })], 1)]], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };